export default {"src":"/_next/static/media/download-play-store.42d4b428.svg","height":67,"width":183,"blurWidth":0,"blurHeight":0};